import React from "react";
import Lottie from "react-lottie";
import { Row, Col } from "antd";
import { useNavigate } from "react-router-dom"; // Import the useNavigate hook
import underConstAnimation from "../assets/lotties/underContruction.json";
import underConstSvg from "../assets/Illustrations/underConstruction.svg";

function UnderConstructionLandingPage({ redirect }) {
  const navigate = useNavigate(); // Initialize useNavigate

  const underConstructionJson = {
    loop: true,
    autoplay: true,
    animationData: underConstAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const handleBack = () => {
    navigate("/dashboard"); // Navigate to /dashboard path
  };
  const handleRedirect = () => {
    window.location.href = "https://www.hireplusplus.com/contact-us";
  };

  return (
    <Row
      align="middle"
      justify="center"
      style={{
        height: "75vh",
        padding: "16px",
        textAlign: "center",
      }}
    >
      <Col>
        {/* <Lottie height={380} width={380} options={underConstructionJson} /> */}
        <img src={underConstSvg} width={420} alt="under-construction" />
        <div className="mt-3 font-medium text-[1.1rem] text-[#475467]">
          Page under construction. Please check back soon!
        </div>

        {/* <Button
          type="primary"
          onClick={handleBack}
          style={{ marginTop: "12px" }}
        >
          Back to Dashboard
        </Button> */}
      </Col>
    </Row>
  );
}

export default UnderConstructionLandingPage;
